"use strict";
import classNames from "classnames";
import { Flash } from "../components/flash_messages";
import ValueLinkTextDroppableInput from "./value_link_text_droppable_input";
import DisablingButton from "./disabling_button";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import paymentAddressIntegrationValidator from "./payment_address_integration_validator";
const PaymentAddressEditor = React.createClass({
  propTypes: {
    saveAddress: React.PropTypes.func,
    accountSettings: React.PropTypes.object,
    address: React.PropTypes.object
  },
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return _.extend({ blurredFields: [] }, this.props.address || {});
  },
  componentWillReceiveProps: function(props) {
    this.setState(props.address || {});
  },
  componentWillMount: function() {
    this.integrationValidator = paymentAddressIntegrationValidator(this.props.accountSettings);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row", ref: "container" }, this.possibleErrorMessages(), /* @__PURE__ */ React.createElement("div", { className: "small-12 column required-legend" }, /* @__PURE__ */ React.createElement("i", { className: "fi-asterisk required" }), " Required fields"), /* @__PURE__ */ React.createElement("form", { onSubmit: this.saveAddress }, _.map(this.fields, this.field), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "expand button--confirmation",
        disabledText: this.isInvalid() ? "Enter all fields to save" : "Saving...",
        disabled: this.state.saving || this.isInvalid()
      },
      "Save Address"
    ))));
  },
  fields: [
    {
      label: "Name",
      value: "name",
      width: 12,
      required: true
    },
    {
      label: "Address Line 1",
      value: "address_line_1",
      width: 5,
      required: true
    },
    {
      label: "Address Line 2",
      value: "address_line_2",
      width: 5
    },
    {
      label: "City",
      value: "city",
      width: 5,
      required: true
    },
    {
      label: "State",
      value: "state",
      width: 2,
      required: true
    },
    {
      label: "Postal Code",
      value: "postal_code",
      width: 3,
      required: true
    },
    {
      label: "Country",
      value: "country",
      width: 10,
      required: false
    }
  ],
  field: function(field) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "small-" + field.width + " column",
        key: "field-" + field.value
      },
      /* @__PURE__ */ React.createElement("label", null, field.label, " ", this.possibleRequiredFlag(
        field
      ), this.possibleValidationIconFor(
        field
      )),
      /* @__PURE__ */ React.createElement(
        ValueLinkTextDroppableInput,
        {
          type: "text",
          "data-name": field.value,
          className: this.fieldClassNames(field),
          onBlur: this.markAsBlurredHandler(field),
          maxLength: "255",
          valueLink: this.linkState(field.value)
        }
      )
    );
  },
  _errorElement: function(e) {
    return /* @__PURE__ */ React.createElement("li", { key: e.field.label + e.errorMessage }, /* @__PURE__ */ React.createElement("i", { className: "warning fi-alert" }), " ", e.field.label, " ", e.errorMessage);
  },
  possibleErrorMessages: function() {
    const visibleFormErrors = this.visibleFormErrors().filter((e) => !_.str.isBlank(e.errorMessage));
    if (visibleFormErrors.length > 0) {
      return /* @__PURE__ */ React.createElement("ul", { className: "warning" }, visibleFormErrors.map(this._errorElement));
    }
  },
  possibleRequiredFlag: function(field) {
    if (field.required) {
      return /* @__PURE__ */ React.createElement("i", { className: "fi-asterisk required" });
    }
  },
  markAsBlurredHandler: function(field) {
    return function() {
      this.setState({ blurredFields: _.union(this.state.blurredFields, [field.value]) });
    }.bind(this);
  },
  visibleFormErrors: function() {
    return _.chain(this.fields).filter(this.shouldDisplayAsInvalid).map(function(f) {
      return { field: f, errorMessage: this.errorMessageForField(f) };
    }.bind(this)).value();
  },
  possibleValidationIconFor: function(field) {
    if (this.shouldDisplayAsInvalid(field)) {
      return /* @__PURE__ */ React.createElement("span", null, "\xA0", /* @__PURE__ */ React.createElement("i", { className: "warning fi-alert" }));
    }
  },
  shouldDisplayAsInvalid: function(field) {
    const hasVisibleRequiredError = this.state.blurredFields.includes(
      field.value
    ) && this.doesFieldHaveRequiredError(field);
    return hasVisibleRequiredError || this.doesFieldHaveIntegrationValidationError(field);
  },
  doesFieldHaveIntegrationValidationError: function(field) {
    return !this.integrationValidator.validate(field.value, this.state[field.value]).valid;
  },
  doesFieldHaveRequiredError: function(field) {
    return field.required && _.str.isBlank(this.state[field.value]);
  },
  fieldClassNames: function(field) {
    return classNames({
      validatingFormField: true,
      invalid: this.shouldDisplayAsInvalid(field)
    });
  },
  isInvalid: function() {
    return _.any(this.fields, _.negate(this.isFieldValid));
  },
  isFieldValid: function(field) {
    const noRequiredErrors = !this.doesFieldHaveRequiredError(field);
    const noIntegrationValidationError = !this.doesFieldHaveIntegrationValidationError(field);
    return noRequiredErrors && noIntegrationValidationError;
  },
  errorMessageForField: function(field) {
    return this.integrationValidator.validate(field.value, this.state[field.value]).errorMessage;
  },
  saveAddress: function(e) {
    e.preventDefault();
    this.setState({ saving: true });
    this.props.saveAddress(this.state).then(function(arg) {
      Flash.success("Address successfully updated!");
      if (this.isMounted()) {
        this.setState({ saving: false });
      }
      return arg;
    }.bind(this), function(arg) {
      if (this.isMounted()) {
        this.setState({ saving: false });
      }
      return arg;
    }.bind(this));
  }
});
export default PaymentAddressEditor;
